import type {
  DashboardSummaryInput,
  getDashboardSummaryQuery,
  getProviderClaimsMetricsQuery,
  getProviderDashboardSummaryQuery,
} from "../../remote/gql/graphql";
import type { ClientReturnType } from "../types";
import type { AlaffiaClientModuleArgs } from "./modules";

import { getDashboardSummaryQueryDoc } from "../../remote/queries/getDashboardSummary.gql";
import { getProviderClaimsMetricsQueryDoc } from "../../remote/queries/getProviderClaimsMetrics.gql";
import { getProviderDashboardSummaryQueryDoc } from "../../remote/queries/getProviderDashboardSummary.gql";
import { AlaffiaClientModule } from "./modules";

type DashboardModuleArgs = AlaffiaClientModuleArgs;

export class DashboardModule extends AlaffiaClientModule {
  constructor(args: DashboardModuleArgs) {
    super(args);
  }

  getDashboardSummary = async (
    input: DashboardSummaryInput,
  ): ClientReturnType<getDashboardSummaryQuery["dashboardSummary"]> => {
    const result = await this.runGqlQuery(
      getDashboardSummaryQueryDoc,
      { input },
      "getDashboardSummary",
    );
    return {
      data: result.data?.dashboardSummary ?? null,
      error: result.error ?? null,
    };
  };

  getProviderClaimsMetrics = async (): ClientReturnType<
    getProviderClaimsMetricsQuery["providerClaimsMetrics"]
  > => {
    const result = await this.runGqlQuery(
      getProviderClaimsMetricsQueryDoc,
      {},
      "getProviderClaimsMetrics",
    );
    return {
      data: result.data?.providerClaimsMetrics ?? null,
      error: result.error ?? null,
    };
  };

  getProviderDashboardSummary = async (): ClientReturnType<
    getProviderDashboardSummaryQuery["providerDashboardSummary"]
  > => {
    const result = await this.runGqlQuery(
      getProviderDashboardSummaryQueryDoc,
      {},
      "getProviderDashboardSummary",
    );
    return {
      data: result.data?.providerDashboardSummary ?? null,
      error: result.error ?? null,
    };
  };
}
